import axios from "axios";
import Cookies from "js-cookie";
import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_SAVE_PAYMENT,
  CART_SAVE_SHIPPING,
} from "../reducers/actionTypes";

const addToCart = (productId, qty) => async (dispatch, getState) => {
  const { data } = await axios.get(`/api/products/${productId}`);

  dispatch({
    type: CART_ADD_ITEM,
    payload: {
      product: data._id,
      name: data.name,
      image: data.image,
      price: data.price,
      countInStock: data.countInStock,
      qty,
    },
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

// remove cart items
const removeFromCart = (productId) => (dispatch, getState) => {
  dispatch({ type: CART_REMOVE_ITEM, payload: productId });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

//payment and shipping

const saveShippingAddress = (data) => (dispatch) => {
  dispatch({ type: CART_SAVE_SHIPPING, payload: data });
  localStorage.setItem("shippingAddress", JSON.stringify(data));
};

const savePaymentMethod = (data) => (dispatch) => {
  dispatch({ type: CART_SAVE_PAYMENT, payload: data });
};

export { addToCart, removeFromCart, saveShippingAddress, savePaymentMethod };

// const addToCart = (productId, qty) => async (dispatch) => {
//   try {
//     const { data } = await axios.get(`/api/products/${productId}`);
//     dispatch({
//       type: CART_ADD_ITEM,
//       payload: {
//         product: data._id,
//         name: data.name,
//         image: data.image,
//         price: data.price,
//         countInStock: data.countInStock,
//         qty,
//       },
//     });
//   } catch (error) {
//     //});
//   }
// };

// const removeFromCart = (productId) => (dispatch) => {
//   dispatch({ type: CART_REMOVE_ITEM, payload: productId });
// };

// export { addToCart, removeFromCart };

//-----------------------------------------//

// import axios from "axios";
// import Cookies from "js-cookie";
// import {
//   CART_ADD_ITEM,
//   CART_REMOVE_ITEM,
//   CART_SAVE_PAYMENT,
//   CART_SAVE_SHIPPING,
// } from "../reducers/actionTypes";

// const addToCart = (productId, qty) => async (dispatch, getState) => {
//   try {
//     const { data } = await axios.get(`/api/products/${productId}`);
//     dispatch({
//       type: CART_ADD_ITEM,
//       payload: {
//         product: data._id,
//         name: data.name,
//         image: data.image,
//         price: data.price,
//         countInStock: data.countInStock,
//         qty,
//       },
//     });

//     const {
//       cart: { cartItems },
//     } = getState();
//     Cookies.set("cartItems", JSON.stringify(cartItems));
//   } catch (error) {
//     //});
//   }
// };

// const removeFromCart = (productId) => (dispatch, getState) => {
//   dispatch({ type: CART_REMOVE_ITEM, payload: productId });

//   const {
//     cart: { cartItems },
//   } = getState();
//   Cookies.set("cartItems", JSON.stringify(cartItems));
// };

// //payment and shipping

// const saveShipping = (data) => (dispatch) => {
//   dispatch({ type: CART_SAVE_SHIPPING, payload: data });
// };

// const savePayment = (data) => (dispatch) => {
//   dispatch({ type: CART_SAVE_PAYMENT, payload: data });
// };

// export { addToCart, removeFromCart, saveShipping, savePayment };

//-------------//

// const addToCart = (productId, qty) => async (dispatch, getState) => {
//   const { data } = await axios.get(`/api/products/${productId}`);
//   dispatch({
//     type: CART_ADD_ITEM,
//     payload: {
//       product: data._id,
//       name: data.name,
//       image: data.image,
//       price: data.price,
//       countInStock: data.countInStock,
//       qty,
//     },
//   });

//   localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
// };
